import { Button } from '../Button';
import { TextInputFieldController } from '../Form';
import styles from './styles.module.scss';

type Props = {
  title: string;
  onSubmit: React.ComponentProps<'form'>['onSubmit'];
  errorMessage: string;
  buttonDisabled: boolean;
  isPartnerCodeHidden?: boolean;
  emailPlaceholder?: string;
};

export const LoginFormContent: React.FC<Props> = ({
  title,
  onSubmit,
  errorMessage,
  buttonDisabled,
  isPartnerCodeHidden = false,
  emailPlaceholder = 'example@example.com',
}) => (
  <div className={styles.LoginFormContent}>
    <div className={styles.LoginFormContent__Title}>{title}</div>
    <div className={styles.LoginFormContent__ErrorMessage}>{errorMessage}</div>
    <form onSubmit={onSubmit}>
      <div className={styles.LoginFormContent__Form}>
        <TextInputFieldController
          name='email'
          fieldWrapperProps={{ labelText: 'メールアドレス' }}
          textInput={{ type: 'text', placeholder: emailPlaceholder }}
        />
        <TextInputFieldController
          name='password'
          fieldWrapperProps={{ labelText: 'パスワード' }}
          textInput={{ type: 'password', placeholder: '********' }}
        />
        {!isPartnerCodeHidden && (
          <TextInputFieldController
            name='partnerCode'
            fieldWrapperProps={{ labelText: 'パートナーコード' }}
            textInput={{ type: 'text', placeholder: 'ABC' }}
          />
        )}
        <Button type='submit' size='lg' disabled={buttonDisabled} fullWidth>
          ログイン
        </Button>
      </div>
    </form>
  </div>
);
